import { PenaltyDescriptionId } from '@/warranty/domain/entities/penalty-description-id';
import type { PenaltyOverviewChartData } from '@/warranty/domain/entities/warranty-penalty-chart-data';
import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

export const dummyPenaltyOverviewChartData: PenaltyOverviewChartData[] = [
  // fullFrontendId: 'Smart_Hill/B01/Rack_10', // complianceStatus: 1
  // fullFrontendId: 'Smart_Hill/B02/Rack_10', // complianceStatus: 1
  // fullFrontendId: 'Smart_Hill/B19/Rack_05', // complianceStatus: 1
  // fullFrontendId: 'Smart_Hill/B05/Rack_03', // complianceStatus: 2
  {
    id: 'A123',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_10',
    fullFrontendId: 'Smart_Hill/B01/Rack_10',
    penalties: [
      {
        type: PenaltyDescriptionId.C_RATE_HIGH,
        yearToDate: 0.0001, // NOTE: use tiny number to display the row for demo purpose
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.TP_HIGH_DCH,
        yearToDate: 0.0001, // NOTE: use tiny number to display the row for demo purpose
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.SOC_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.RSOC_HIGH,
        yearToDate: 0.0001, // NOTE: use tiny number to display the row for demo purpose
        futurePrediction: 1,
        windowEndDate: new Date('2024-04-15'), // Example: 1.5 months prediction window
      },
      {
        type: PenaltyDescriptionId.TEMPERATURE_HIGH,
        yearToDate: 1,
        futurePrediction: 1,
        windowEndDate: new Date('2024-05-01'), // Example: 2 months prediction window
      },
      {
        type: PenaltyDescriptionId.DOD_HIGH_CHA,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
    ],
  },
  {
    id: 'A123',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_10',
    fullFrontendId: 'Smart_Hill/B02/Rack_10',
    penalties: [
      {
        type: PenaltyDescriptionId.C_RATE_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.TP_HIGH_DCH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.SOC_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.RSOC_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.TEMPERATURE_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.DOD_HIGH_CHA,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
    ],
  },
  {
    id: 'A123',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_05',
    fullFrontendId: 'Smart_Hill/B19/Rack_05',
    penalties: [
      {
        type: PenaltyDescriptionId.C_RATE_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.TP_HIGH_DCH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.SOC_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.RSOC_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.TEMPERATURE_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.DOD_HIGH_CHA,
        yearToDate: 0.5,
        futurePrediction: 0.5,
        windowEndDate: new Date('2024-03-30'), // Example: short prediction window
      },
    ],
  },
  {
    id: 'A123',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_03',
    fullFrontendId: 'Smart_Hill/B05/Rack_03',
    penalties: [
      {
        type: PenaltyDescriptionId.C_RATE_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.TP_HIGH_DCH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.SOC_HIGH,
        yearToDate: 0,
        futurePrediction: 3,
        windowEndDate: new Date('2024-04-30'), // Example: 2 months prediction window
      },
      {
        type: PenaltyDescriptionId.RSOC_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
      {
        type: PenaltyDescriptionId.TEMPERATURE_HIGH,
        yearToDate: 0,
        futurePrediction: 0,
        windowEndDate: undefined,
      },
    ],
  },
];

export const dummyPenaltyOverview: IWarrantyRepository.GetPenaltyOverviewOutput =
  [
    // Country_Corner
    // -> no penalties

    // Sunset_Plaza
    // -> no penalties

    // Smart_Hill
    {
      id: 'PEN1',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_10',
      fullFrontendId: 'Smart_Hill/B01/Rack_10',
      description: PenaltyDescriptionId.TEMPERATURE_HIGH,
      extremeValue: 38,
      unit: '°C',
      latestDetect: new Date('2024-03-01'),
      duration: 0.5,
      totalCount: 1,
      sohPenalty: 1,
    },
    {
      id: 'PEN2',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B19',
      unitFullId: 'Smart_Hill/B19/Rack_05',
      fullFrontendId: 'Smart_Hill/B19/Rack_05',
      description: PenaltyDescriptionId.DOD_HIGH_CHA,
      extremeValue: 92,
      unit: '%',
      latestDetect: new Date('2024-03-03'),
      duration: 2,
      totalCount: 1,
      sohPenalty: 0.5,
    },
    {
      id: 'PEN3',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B05',
      unitFullId: 'Smart_Hill/B05/Rack_03',
      fullFrontendId: 'Smart_Hill/B05/Rack_03',
      description: PenaltyDescriptionId.SOC_HIGH,
      extremeValue: 88,
      unit: '%',
      latestDetect: new Date('2024-03-04'),
      duration: 5,
      totalCount: 4,
      sohPenalty: 3,
    },
  ];
